import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetNotification, GetNotificationParams } from "../../domain/usecases/getPlaces";
import { DeleteNotification, DeleteNotificationParams } from "../../domain/usecases/deleteNotification";
import { OnPurchaseMessageNotification } from "../../domain/usecases/onPurchaseMessageNotification";
import { ConnectSocketNotification } from "../../domain/usecases/connectSocket";
import { NotificationDisconnectSocket } from "../../domain/usecases/disconnectSocket";
import { setUpdateCreditsUser } from "../../../profile/presentation/store/OnboardingSlice";

export const onGetNotification = createAsyncThunk(
	"notification/notification",
	async (params: GetNotificationParams, { extra }) => {
		const { getNotification } = extra as {
			getNotification: GetNotification;
		};
		const result = await getNotification.execute(params);
		return result;
	}
);

export const onDeleteNotification = createAsyncThunk(
	"notification/deleteNotification",
	async (params: DeleteNotificationParams, { extra }) => {
		const { deleteNotification } = extra as {
			deleteNotification: DeleteNotification;
		};
		await deleteNotification.execute(params);
	}
);

export const onPurchaseMessageNotification = createAsyncThunk(
	"notification/purchase-message-notification",
	async (_, { extra, dispatch }) => {
		const { onPurchaseMessageNotification } = extra as {
			onPurchaseMessageNotification: OnPurchaseMessageNotification;
		};
		onPurchaseMessageNotification.execute((data: number) => {
			dispatch(setUpdateCreditsUser(data));
		});
	}
);

export const onConnectSockeNotification = createAsyncThunk(
	"notification/connect-socket",
	async (_, { extra }) => {
		const { connectSocketNotification } = extra as {
			connectSocketNotification: ConnectSocketNotification;
		};
		await connectSocketNotification.execute();
		return;
	}
);

export const onDisconnectSocketNotification = createAsyncThunk(
	"notification/disconnect-socket",
	async (_, { extra }) => {
		const { notificationDisconnectSocket } = extra as {
			notificationDisconnectSocket: NotificationDisconnectSocket;
		};
		await notificationDisconnectSocket.execute();
		return;
	}
);
